
























































































































































import ICompanySettings from '@/store/models/ICompanySettings';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';

@Component({
    components: {
        Snackbar
    }
})
export default class CompanySettingsSelector extends Vue {
    searchCompanySettings: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Company', value: 'companyName' },
        { text: 'KeySetting', value: 'keySetting' },
        { text: 'Description', value: 'description' },
        { text: 'Value', value: 'value' }
    ];
    editedIndex : number = -1;
    editedItem : ICompanySettings = {
        id: "",
        idCompany: "",
        companyName: "",
        keySetting: "",
        description: "",
        value: ""
    }
    defaultItem : ICompanySettings = {
        id: "",
        idCompany: "",
        companyName: "",
        keySetting: "",
        description: "",
        value: ""
    }
    sortBy: string = 'companyName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    CompanySettingsList !: ICompanySettings[];
    @Prop({ type: Array, required: true })
    CompaniesList !: ICompany[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedCompanySettings : ICompanySettings[] = [];
    selectedCompany : ICompany = {} as ICompany;

    get formTitle() { return this.editedIndex === -1 ? 'New Company Setting' : 'Edit Company Setting'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetCompanySettingss() {
        this.selectedCompanySettings = [];
        this.selectedCompany = {} as ICompany;
    }

    editCompanySettings (item: any, dbox = true) {
        this.editedIndex = this.CompanySettingsList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        let index = this.CompaniesList.findIndex(c => c.id === this.editedItem.idCompany);
        if (index > -1) {
            this.selectedCompany = this.CompaniesList[index];
        }
        this.dialog = true;
    }

    saveCompanySettings (country: ICompanySettings) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.idCompany = this.selectedCompany.id;
            this.editedItem.companyName = this.selectedCompany.name;
            if (this.editedIndex > -1 || this.selectedCompanySettings[0]) {
                this.close();
                this.$emit('editCompanySettings', this.editedItem);
                Object.assign(this.CompanySettingsList[this.editedIndex], this.editedItem);
            } else {
                this.selectedCompanySettings[0] = this.editedItem;
                this.$emit('saveCompanySettings', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteCompanySettings (country: ICompanySettings) {
        this.$emit('deleteCompanySettings', country);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectCompanySettings(item : any) : void {
        if (!this.selectedCompanySettings.includes(item)) {
            this.selectedCompanySettings = [];
            this.selectedCompanySettings = [item];
        } else {
            this.selectedCompanySettings = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
